import { constants } from '../utils/constants';

export class Role {
  public id?: number;
  public uri: string;
  public name: string;
  public fullName: string;

  constructor(uri: string, fullName?: string) {
    this.uri = uri;
    this.id = this.getIdByUri(uri);
    this.name = this.getNameById(this.id);
    if (fullName) {
      this.fullName = fullName;
    }
  }

  private getIdByUri(uri: string): any {
    return parseInt(uri.split("@")[1]);
  }

  private getNameById(id: number): string {
    switch (id) {
      case constants.rules.codes.roles.admin.value:
        return constants.rules.codes.roles.admin.name;
      case constants.rules.codes.roles.responsibleForRequests.value:
        return constants.rules.codes.roles.responsibleForRequests.name;
      case constants.rules.codes.roles.treasurer.value:
        return constants.rules.codes.roles.treasurer.name;
      case constants.rules.codes.roles.supervisor.value:
        return constants.rules.codes.roles.supervisor.name;
    }
  }
}
